/** @format */

import { useAppSelector } from "../../app/hooks";
import ResourcesIndexUI from "../resources/resourceIndexUI/ResourcesIndexUI";
import { useGetForUserQuery } from "../../app/services/userResourceApi";
import { useLocale } from "../../i18n/hooks";
import { Spinner } from "react-bootstrap";

const UserResourceIndex = () => {
  const isAuthenticated =
    useAppSelector((state) => state.auth.userToken?.token) || false;
  const { data, isLoading } = useGetForUserQuery(undefined, {
    skip: !isAuthenticated,
  });
  const locale = useLocale();

  return (
    <div>
      {isLoading ? (
        <div className="position-absolute top-50 start-50 translate-middle">
          <Spinner />
        </div>
      ) : (
        <ResourcesIndexUI
          resources={(data ?? []).filter((resource) => resource.Locale === locale)}
          filters={["qualification", "level", "cat", "tag"]}
        />
      )}
    </div>
  );
};

export default UserResourceIndex;
